__turbopack_context__.v({
  "full": "SortControl-module-scss-module__6d0HKq__full",
  "options": "SortControl-module-scss-module__6d0HKq__options",
  "short": "SortControl-module-scss-module__6d0HKq__short",
  "single": "SortControl-module-scss-module__6d0HKq__single",
  "sort": "SortControl-module-scss-module__6d0HKq__sort",
});
